<div class="modal-content">
  <div class="modal-header">
    <div class="modal-header-left" style="font-size: larger; font-weight: bold">
      <a
        class="modal-title"
        [routerLink]="editLink"
        target="_blank"
        routerLinkActive="router-link-active"
      >
        View Record
      </a>
    </div>
    <div class="modal-header-right">
      <button type="button" class="close" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <form class="modal-body" [formGroup]="form">
    <div class="modal-body-inner">
      <div class="form-custom-div">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <app-input
              controlName="Name"
              [form]="form"
              label="Event"
              [disabled]="true"
            ></app-input>
          </div>
          <div class="col-lg-12 col-md-12">
            <app-input
              class="form-group"
              label="Event Start Time"
              [form]="form"
              controlName="EventStart"
              type="datetime-local"
              [disabled]="true"
            ></app-input>
          </div>
          <div class="col-lg-12 col-md-12">
            <app-input
              class="form-group"
              label="Event End Time"
              [form]="form"
              controlName="EventEnd"
              type="{{form.controls.EventEnd.value !== ' ' ? 'datetime-local' : 'text'}}"
              [disabled]="true"
            ></app-input>
          </div>
          <div
            class="col-lg-12 col-md-12"
            *ngIf="reportsData.EventAllDayFieldData != null"
          >
            <app-checkbox
              [form]="form"
              label="All Day Event"
              controlName="EventAllDay"
            ></app-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer-bottom">
      <div class="modal-footer-bottom-row">
        <app-button
          [style]="'secondary'"
          title="Cancel"
          (onClick)="close()"
          class="mr-2"
        ></app-button>
      </div>
    </div>
  </form>
</div>
